<template>
  <v-dialog :value="isActive" persistent max-width="900" scrollable>
    <v-card :loading="isLoading">
      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            Detalles
          </v-card-title>
        </v-img>
      </v-card-title>

      <vuescroll
        :ops="{
          bar: { background: '#bacfcec0', keepShow: true },
        }"
      >
        <v-card-text style="max-height: 450px">
          <v-row dense class="py-8">
            <v-col cols="12" md="8">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.name
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Name</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.dni
                  }}</v-list-item-title>
                  <v-list-item-subtitle>DNI</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.country
                  }}</v-list-item-title>
                  <v-list-item-subtitle>País</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.direction
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Direción</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.telefono1
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Telefono 1</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.status.name
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Status</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.var1
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Variable 1</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.var2
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Variable 2</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.var3
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Variable 3</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.var4
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Variable 4</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.var5
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Variable 5</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.var6
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Variable 6</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.var7
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Variable 7</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.var8
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Variable 8</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.var9
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Variable 9</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.var10
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Variable 10</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.updated_at
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Fecha de Act.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <!-- <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.in_use
                  }}</v-list-item-title>
                  <v-list-item-subtitle>in_use</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col> -->

            <!-- <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.time_in_use
                  }}</v-list-item-title>
                  <v-list-item-subtitle>time_in_use</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col> -->

            <!-- <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.user_update
                  }}</v-list-item-title>
                  <v-list-item-subtitle>user_update</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col> -->

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.text
                  }}</v-list-item-title>
                  <v-list-item-subtitle>text</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.value
                  }}</v-list-item-title>
                  <v-list-item-subtitle>value</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12" md="6" lg="8">
              <v-list-item two-line small>
                <v-list-item-content>
                  <div class="body-2">{{ details.description }}</div>
                  <v-list-item-subtitle>description</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <!-- <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.count_call
                  }}</v-list-item-title>
                  <v-list-item-subtitle>count_call</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col> -->

            <!-- <v-col cols="12" md="6" lg="4">
              <v-list-item two-line small>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{
                    details.phone_call
                  }}</v-list-item-title>
                  <v-list-item-subtitle>phone_call</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col> -->
          </v-row>

          <!-- {{ details }} -->
        </v-card-text>
      </vuescroll>

      <v-card-actions>
        <v-btn
          @click="closeDialog()"
          class="px-8"
          color="error"
          rounded
          large
          text
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      isLoading: false,
      showPassword: false,
      details: [],
      payload: {
        public_identity: "",
        Password: "",
        user_id: "",
      },
    };
  },

  //   computed: {
  //     Properties() {
  //       return Object.keys(this.item)
  //         .filter(
  //           (el) =>
  //             ![
  //               "id",
  //               "name",
  //               "dni",
  //               "direction",
  //               "created_at",
  //               "campaign_id",
  //               "user_id",
  //               "state",
  //               "status",
  //               "campaign",
  //             ].includes(el)
  //         )
  //         .filter((el) =>
  //           el.toLocaleLowerCase().includes("telefono")
  //             ? Boolean(Number(this.item[el]))
  //             : true
  //         );
  //     },
  //   },

  created() {
    this.getDetailsInfo();
  },

  methods: {
    closeDialog() {
      this.$emit("close:dialog");
    },

    async getDetailsInfo() {
      // this.isLoading = true;
      const payload = {
        phone: this.data.call_number,
      };

      // const json = this.data.variable_1;
      // const match = json.match(/campaing_id:([^}]+)/);
      const valor = this.data.campaign_id;
      // Test de impresión de valor
      //   if (match && match.length > 1) {
      //     const valor = match[1];
      //     console.log("Valor:", valor); // Resultado: "12345"
      //   } else {
      //     console.log("No se encontró el valor de campaign_id");
      //   }

      const { data } = await PbxHttpClient.post(
        `/campaign/search_register/${valor}`,
        payload
      );

      this.details = data.data[0];
    },
  },
};
</script>
